import { TableSearchBar } from 'components/tables/TableSearchBar';
import { useDepartmentsStore } from 'pages/admin-dashboard/departments/store';
import styled from 'styled-components';

export const DepartmentsTableToolbar = () => {
  const { setPageNumber, name, setName } = useDepartmentsStore();
  return (
    <ToolbarContainer>
      <TableSearchBar
        value={name}
        onChange={setName}
        resetPage={() => setPageNumber(1)}
        placeholder="Search departments by name..."
      />
    </ToolbarContainer>
  );
};

const ToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
  margin-top: 1em;
  align-items: center;
`;
